document.addEventListener("scroll", (event) => {
    try {
        if (window.scrollY > 78) {
            document.getElementById("customHeaderContainer").style.position = 'fixed';
            document.getElementById("customHeaderContainer").style.top = '74px';
            document.getElementById("customHeaderContainer").style.zIndex = '999';
            document.getElementById("customHeaderContainer").style.width = document.getElementById("initialWidth").value + 'px';
        }
        else
            document.getElementById("customHeaderContainer").style.position = '';

        var isEnd = ((window.innerHeight + window.scrollY) >= document.body.scrollHeight);

        var items = document.getElementsByClassName("containerPart");

        var foundIndex = -1;

        if (isEnd) {
            foundIndex = items.length - 1;
        }
        else {
            for (var i = 0; i < items.length; i++) {
                if (foundIndex == -1 && isVisible(items[i]))
                    foundIndex = i;
            }
        }

        for (var i = 0; i < items.length; i++) {
            if (i == foundIndex)
                document.getElementById("page-header-" + i).className = "actionIcon bg-primary text-white p-2 text-center"
            else
                document.getElementById("page-header-" + i).className = "actionIcon bg-white text-primary p-2 text-center"
        }
    } catch (error) {

    }
});

function isVisible(el) {
    if (!el || !typeof el.getBoundingClientRect === "function") return false;
    const r = el.getBoundingClientRect();
    const vw = document.documentElement.clientWidth;
    const vh = document.documentElement.clientHeight;
    var _top = r.top + 120;
    var _bottom = r.bottom - 120;
    const inViewX = (r.left > 0 && r.left < vw) || (r.right < vw && r.right > 0);
    const inViewY = (_top > 0 && _top < vh) || (_bottom < vh && _bottom > 0);
    return inViewX && inViewY;
}